export const initialState = {
  loading: false,
  error: null,
  loadingUserHistory: false,
  userNotificationHistory: [],
  userNotificationDays: 0,
};

export const RESET_ERROR = 'notifications/RESET_ERROR';

export const FETCH_USER_HISTORY = 'notifications/FETCH_USER_HISTORY';
export const FETCH_USER_HISTORY_SUCCESS = 'notifications/FETCH_USER_HISTORY_SUCCESS';
export const FETCH_USER_HISTORY_FAIL = 'notifications/FETCH_USER_HISTORY_FAIL';
